export const GET_STORES = 'GET_STORES';
export const GET_CART_VARIANTS = 'GET_CART_VARIANTS';
export const UPDATE_CART_VARIANTS = 'UPDATE_CART_VARIANTS';
export const UPDATE_CART = 'UPDATE_CART';
export const ADD_ID_RETAILER = 'ADD_ID_RETAILER';
export const CART_TOTAL = 'CART_TOTAL';
export const CART_LOADING = 'CART_LOADING';
export const CART_LOADING_FORM = 'CART_LOADING_FORM';
export const SUCCESS_ORDER = 'SUCCESS_ORDER';
export const CART_ERROR = 'CART_ERROR';
